const normalizeCJSyncError = (error) => ({
  code: error?.code || "CJ_SYNC_REQUEST_FAILED",
  message: error?.message || "CJ synchronization failed.",
  errors: Array.isArray(error?.errors) ? error.errors : [],
  warnings: Array.isArray(error?.warnings) ? error.warnings : [],
  status: error?.status,
});

const wrap = async (operation) => {
  try { return await operation(); }
  catch (error) { throw Object.assign(new Error(normalizeCJSyncError(error).message), normalizeCJSyncError(error)); }
};

const createCJSyncService = (api) => ({
  getCJSync: (syncId) => wrap(() => api.compareCJProduct(syncId)),
  validateCJSync: (payload) => wrap(() => api.validateCJSync ? api.validateCJSync(payload) : Promise.resolve({ success: true, data: payload })),
  finalizeCJSync: (operation) => wrap(operation),
  updateCJSync: (productId, mapping, locks, options) => wrap(() => api.syncCJProductWithMapping(productId, mapping, locks, options)),
  deleteCJSync: (productId, options, confirmation) => wrap(() => api.deleteCJProduct(productId, options, confirmation)),
  updateCJSyncFilter: (operation) => wrap(operation),
  deleteCJSyncFilter: (operation) => wrap(operation),
  syncAllCJProducts: (options, confirmation) => wrap(() => api.syncAll(options, confirmation)),
});

module.exports = { createCJSyncService, normalizeCJSyncError };
